import React from 'react'
import Radium from 'radium'

class CardWithIcon extends React.PureComponent {
  state = {
    play: 'stop'
  }

  animate = () => {
    this.setState({play: 'loop'});
  };

  pause = () => {
    this.setState({play: 'stop'});
  };

  render () {
    const icon = React.createElement(this.props.icon, {states: {play: {value: this.state.play}}});
    return (
      <div style={this.props.style} onMouseEnter={this.animate} onMouseLeave={this.pause}>
        <div style={{height: 90}}>
          {icon}
        </div>
        {this.props.children}
      </div>
    )
  }
}

export default Radium(CardWithIcon);



// WEBPACK FOOTER //
// ./src/components/card-with-icon.js